import { createContext, useContext, useEffect, useCallback, useRef, useMemo } from "react";
import { useAuth } from "./AuthContext";
import { logDebug } from "../lib/logger";

const RtCtx = createContext(null);

export function RealtimeProvider({ children }) {
  const { user } = useAuth();
  const handlersRef = useRef(new Set());

  useEffect(() => {
    if (!user) return undefined;
    const es = new EventSource(`${process.env.REACT_APP_BACKEND_URL}/api/events`, { withCredentials: true });
    es.onmessage = (e) => {
      try {
        const evt = JSON.parse(e.data);
        handlersRef.current.forEach((h) => h(evt));
      } catch (err) {
        logDebug("SSE parse failed:", err);
      }
    };
    es.onerror = () => logDebug("SSE connection interrupted — EventSource auto-reconnects");
    return () => es.close();
  }, [user]);

  const subscribe = useCallback((handler) => {
    handlersRef.current.add(handler);
    return () => handlersRef.current.delete(handler);
  }, []);

  const value = useMemo(() => ({ subscribe }), [subscribe]);
  return <RtCtx.Provider value={value}>{children}</RtCtx.Provider>;
}

export const useRealtime = () => useContext(RtCtx);
